import { intercom } from '@/lib/analytics';

export function intercomPlugin(intercom) {
  function update() {
    intercom('update', {
      hide_default_launcher: false,
    });
  }

  function install(router) {
    router.afterEach(update);
  }

  return { install, update };
}

export default intercomPlugin(intercom).install;
